export class VideoHel {
  id: string;
  url: string;
  urlEmbed: string;
  fechaCreacion: any;
  fechaEdicion: any;
}
